import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Mail, Camera, Gift } from 'lucide-react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/archive', label: 'Archive' },
];

const FOOTER_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/gallery', label: 'Gallery' },
];

function SubscribeSuccess() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'free';

  const getMessage = () => {
    switch (type) {
      case 'monthly':
        return {
          title: "Welcome, Monthly Supporter!",
          subtitle: "You're now part of the Beach Bum family",
          icon: Gift,
          benefits: [
            "Your supporter badge is now active",
            "You'll get early access to new prints",
            "Behind-the-scenes content coming your way"
          ]
        };
      case 'annual':
        return {
          title: "Welcome, Annual Supporter!",
          subtitle: "You're a true Beach Bum now",
          icon: Gift,
          benefits: [
            "Your supporter badge is now active",
            "You'll get early access to new prints",
            "Behind-the-scenes content coming your way",
            "Watch for your exclusive annual gift!"
          ]
        };
      case 'donation':
        return {
          title: "Thank You for Your Donation!",
          subtitle: "Your generosity means the world",
          icon: Gift,
          benefits: [
            "Your support helps keep the camera clicking",
            "Thank you for being part of this journey"
          ]
        };
      default:
        return {
          title: "You're in — photos are on the way",
          subtitle: "Welcome to the OBX Beach Bum",
          icon: Mail,
          benefits: [
            "New photos straight to your inbox",
            "No algorithms, no paywall — just the work",
            "Unsubscribe anytime"
          ]
        };
    }
  };

  const content = getMessage();
  const IconComponent = content.icon;

  return (
    <div className="substack-site">
      {/* Header */}
      <Header navItems={NAV_ITEMS} />

      {/* Success Content */}
      <main style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '60vh',
        padding: '60px 20px' 
      }}>
        <div style={{ textAlign: 'center', maxWidth: '600px' }}>
          <div style={{ marginBottom: '30px' }}>
            <CheckCircle size={80} color="#28a745" />
          </div>
          
          <h1 style={{ 
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: '36px',
            margin: '0 0 10px',
            color: '#1a1a1a'
          }}>
            {content.title}
          </h1>
          
          <p style={{ fontSize: '18px', color: '#666', margin: '0 0 30px' }}>
            {content.subtitle}
          </p>

          <div style={{ 
            background: '#f8f9fa', 
            borderRadius: '12px', 
            padding: '25px 30px',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            <h3 style={{ 
              fontSize: '16px', 
              margin: '0 0 15px',
              color: '#1a1a1a',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <IconComponent size={20} />
              What's next:
            </h3>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0, 
              margin: 0 
            }}>
              {content.benefits.map((benefit, idx) => (
                <li key={idx} style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '10px',
                  fontSize: '15px',
                  color: '#555',
                  marginBottom: '10px'
                }}>
                  <span style={{ color: '#28a745' }}>✓</span>
                  {benefit}
                </li>
              ))}
            </ul>
          </div>

          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/gallery">
              <Button style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Camera size={18} />
                Browse the Gallery
              </Button>
            </Link>
            <Link to="/archive">
              <Button variant="outline">
                Read Past Posts
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline">
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer links={FOOTER_LINKS} />
    </div>
  );
}

export default SubscribeSuccess;
